import { Box, Skeleton, Paper } from "@mui/material";

export default function ContentSkeleton() {
  return (
    <Box role="status" aria-label="Loading content" sx={{ width: "100%" }}>
      <Skeleton width="35%" height={48} />
      <Paper sx={{ p: { xs: 2, md: 3 }, mt: 2 }}>
        <Skeleton width="60%" height={48} />
        {[0, 1, 2, 3, 4].map((row) => (
          <Skeleton key={row} height={56} />
        ))}
      </Paper>
    </Box>
  );
}

export function CardSkeleton() {
  return (
    <Paper role="status" aria-label="Loading card" sx={{ p: 3 }}>
      <Skeleton width="50%" />
      <Skeleton height={56} />
      <Skeleton />
    </Paper>
  );
}
export function FormSkeleton() {
  return (
    <Box
      role="status"
      aria-label="Loading form"
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: 2,
      }}
    >
      {[0, 1, 2, 3].map((field) => (
        <Skeleton key={field} height={72} />
      ))}
    </Box>
  );
}
